// call.actions.js
import { v4 as uuid } from 'uuid';
import { callConstants as T } from './constants';
import { callService, refreshCallsAuth } from '../calls';
import { unlockAudio } from '../utils/audioUnlock';

let guardUntil = 0;

const setMeId = (user) => {
    const id = user?._id || user?.id || null;

    if (id) {
        window.__ME_ID__ = String(id);
    }

    return id;
};

export const startCall = ({ to, video = false, chatId = null }) => async (dispatch, getState) => {
    const me = getState().auth?.user;
    const status = getState().call?.status;
    const now = Date.now();

    if (!me?._id) {
        dispatch({ type: T.ERROR, error: 'Нет пользователя' });
        return;
    }

    if (!to) {
        dispatch({ type: T.ERROR, error: 'Не выбран собеседник' });
        return;
    }

    if (now < guardUntil) return;
    if (status && status !== 'idle') return;

    guardUntil = now + 1200;

    const myId = setMeId(me);
    const callId = uuid();
    const mode = video ? 'video' : 'audio';

    refreshCallsAuth();

    dispatch({
        type: T.INVITE,
        callId,
        peerId: to,
        mode,
        chatId,
    });

    try {
        await unlockAudio().catch(() => { });

        await callService.start({
            callId,
            from: myId,
            to,
            video,
            chatId,
        });
    } catch (error) {
        const message = error?.name === 'NotAllowedError'
            ? 'Разрешите доступ к микрофону/камере в браузере'
            : error?.message || 'Ошибка старта звонка';

        dispatch({ type: T.ERROR, error: message });
    }
};

export const acceptCall = () => async (dispatch, getState) => {
    const state = getState().call;
    const me = getState().auth?.user;
    const myId = setMeId(me);

    if (!state?.callId || !state?.peerId || !myId) return;

    refreshCallsAuth();

    try {
        await unlockAudio();

        dispatch({
            type: T.CONNECTING,
        });

        await callService.accept({
            callId: state.callId,
            from: state.peerId,
            to: myId,
            video: state.mode === 'video',
        });
    } catch (error) {
        dispatch({
            type: T.ERROR,
            error: error?.message || 'Ошибка принятия звонка',
        });
    }
};

export const rejectCall = () => async (dispatch, getState) => {
    const state = getState().call;
    const me = getState().auth?.user;
    const myId = setMeId(me);

    if (!state?.callId) return;

    try {
        callService.reject({
            callId: state.callId,
            from: state.peerId,
            to: myId,
        });
    } catch (_error) { }

    dispatch({ type: T.ENDED });
};

export const hangup = (reason = 'ended') => async (dispatch, getState) => {
    const me = getState().auth?.user;
    const myId = setMeId(me);

    try {
        callService.hangup(reason, myId || null);
    } catch (_error) { }

    dispatch({ type: T.ENDED });
};

export const toggleMic = () => (dispatch) => {
    const enabled = callService.toggleMute();

    dispatch({
        type: T.TOGGLE_MIC,
        enabled,
    });
};

export const toggleCam = () => (dispatch) => {
    const enabled = callService.toggleVideo();

    dispatch({
        type: T.TOGGLE_CAM,
        enabled,
    });
};

export const minimizeCallUI = () => ({ type: T.MINIMIZE });

export const restoreCallUI = () => ({ type: T.RESTORE });

export const reportQuality = (level) => () => {
    callService.reportQuality(level);
};